export default function WordMark({ compact = false, small = false }) {
  const size = compact ? "h-9" : small ? "h-12" : "h-20";
  return (
    <img
      src="/images/logo.webp"
      alt="V-Elite Drives"
      data-testid="brand-wordmark"
      draggable="false"
      className={`select-none ${size} w-auto`}
    />
  );
}
